__turbopack_context__.v({
  "cell": "styles-module__mz6qCq__cell",
  "corner": "styles-module__mz6qCq__corner",
  "dayLabel": "styles-module__mz6qCq__dayLabel",
  "frame": "styles-module__mz6qCq__frame",
  "legend": "styles-module__mz6qCq__legend",
  "row": "styles-module__mz6qCq__row",
  "spans": "styles-module__mz6qCq__spans",
  "swatch": "styles-module__mz6qCq__swatch",
  "tick": "styles-module__mz6qCq__tick",
  "week": "styles-module__mz6qCq__week",
});
